import React from "react";
import image1 from "./scholarship.jpeg";
import image2 from "./grants.jpg";
import image3 from "./international.jpg";

const ProgramsScholarships = () => {
  const programsData = [
    {
      id: 1,
      title: "Education Scholarships",
      description:
        "We provide financial support to promising students from low-income backgrounds to pursue their educational goals and realize their full potential.",
      buttonText: "APPLY NOW",
      buttonAction: "apply",
      image: image1,
    },
    {
      id: 2,
      title: "Community Grants",
      description:
        "Our grants support grassroots projects that address local needs and create sustainable solutions for community development.",
      buttonText: "SUBMIT PROPOSAL",
      buttonAction: "submit",
      image: image2,
    },
    {
      id: 3,
      title: "International Programs",
      description:
        "We're expanding our reach to Barbados, the UK, and the USA, bringing our successful models of education and community support to new regions.",
      buttonText: "LEARN MORE",
      buttonAction: "learn",
      image: image3,
    },
  ];

  const handleButtonClick = (action, title) => {
    // Handle different actions based on button type
    switch (action) {
      case "apply":
        // Navigate to contact form for scholarship application
        const contactSection = document.getElementById("contact");
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: "smooth" });
        }
        break;
      case "submit":
        // Navigate to contact form for grant proposal
        const contactForGrant = document.getElementById("contact");
        if (contactForGrant) {
          contactForGrant.scrollIntoView({ behavior: "smooth" });
        }
        break;
      case "learn":
        // Navigate to FAQ page for more information
        window.location.href = "/faq";
        break;
      default:
        break;
    }
  };

  return (
    <div className="programs-container">
      <style jsx>{`
        .programs-container {
          font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
            sans-serif;
          padding: 5rem 2rem;
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          min-height: 100vh;
        }

        .programs-wrapper {
          max-width: 1400px;
          margin: 0 auto;
        }

        .section-header {
          text-align: center;
          margin-bottom: 4rem;
        }

        .programs-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          gap: 2.5rem;
          margin-bottom: 3rem;
        }

        .program-card {
          background: #ffffff;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          transform: translateY(0);
          opacity: 0;
          animation: fadeInUp 0.6s ease forwards;
        }

        .program-card:nth-child(2) {
          animation-delay: 0.2s;
        }

        .program-card:nth-child(3) {
          animation-delay: 0.4s;
        }

        .program-card:hover {
          transform: translateY(-12px);
          box-shadow: 0 25px 60px rgba(0, 0, 0, 0.15);
        }

        .card-image {
          position: relative;
          height: 280px;
          overflow: hidden;
        }

        .card-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.4s ease;
        }

        .program-card:hover .card-image img {
          transform: scale(1.05);
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            45deg,
            rgba(0, 117, 154, 0.3),
            rgba(0, 117, 154, 0.3)
          );
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .program-card:hover .image-overlay {
          opacity: 1;
        }

        .card-content {
          padding: 2.5rem;
        }

        @media (max-width: 1024px) {
          .programs-grid {
            grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
            gap: 2rem;
          }
        }

        @media (max-width: 768px) {
          .programs-container {
            padding: 3rem 1rem;
          }

          .section-title {
            font-size: 2.5rem;
          }

          .programs-grid {
            grid-template-columns: 1fr;
            gap: 1.5rem;
          }

          .card-content {
            padding: 2rem;
          }

          .card-title {
            font-size: 1.5rem;
            color: #2e313c;
          }

          .card-description {
            font-size: 1rem;
          }

          .card-image {
            height: 220px;
          }
        }

        @media (max-width: 480px) {
          .section-title {
            font-size: 2rem;
          }

          .card-content {
            padding: 1.5rem;
          }

          .programs-grid {
            grid-template-columns: 1fr;
            gap: 1.5rem;
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Floating particles animation */
        .programs-container::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: radial-gradient(
              circle at 20% 30%,
              rgba(37, 99, 235, 0.05) 0%,
              transparent 50%
            ),
            radial-gradient(
              circle at 80% 70%,
              rgba(124, 58, 237, 0.05) 0%,
              transparent 50%
            ),
            radial-gradient(
              circle at 60% 20%,
              rgba(245, 158, 11, 0.03) 0%,
              transparent 50%
            );
          pointer-events: none;
          z-index: 0;
        }

        .programs-wrapper {
          position: relative;
          z-index: 1;
        }
      `}</style>

      <div className="programs-wrapper">
        <div className="section-header">
          <h2 className="section-title">Programs & Scholarships</h2>
          <div className="title-underline"></div>
        </div>

        <div className="programs-grid">
          {programsData.map((program, index) => (
            <div key={program.id} className="program-card">
              <div className="card-image">
                <img
                  src={program.image}
                  alt={`${program.title} - ${program.description.substring(0, 100)}`}
                  loading="lazy"
                />
                <div className="image-overlay"></div>
              </div>

              <div className="card-content">
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    color: "var(--primary)",
                    marginBottom: "1rem",
                  }}
                >
                  {program.title}
                </h3>
                <p
                  style={{
                    color: "#475569",
                    fontSize: "1rem",
                    lineHeight: "1.7",
                  }}
                >
                  {program.description}
                </p>

                <button
                  className="cta-button btn-primary"
                  onClick={() =>
                    handleButtonClick(program.buttonAction, program.title)
                  }
                >
                  {program.buttonText}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgramsScholarships;
